import extend from './extend'
let $ = window.$,FE = window.FE

export default {
  extend,
  FE,
  $,

  /**
   * 解析flag中第position位是否为1
   * @param businessFlag
   * @param position
   * @return
   */
  analysisBusinessFlag(businessFlag,position){
    let result=0
    if(businessFlag === undefined || position === undefined){
      return result
    }
    var valueOfPostion = 1 << position-1
    if((businessFlag & valueOfPostion)>0){   // 按位与 大于0表示 postion 位是1
      result=1
    }
    return result
  },

  // 格式化车价
  priceFormat (price) {
    let priceStr,int,float

    price = price>1e4?price/1e4:price
    priceStr = String(price)

    if(priceStr.indexOf('.')>-1){
      int = priceStr.split('.')[0]
      float = priceStr.split('.')[1]

      if(float.length>2){
        float = float.slice(0,2)
      }
    }else {
      int = priceStr
    }

    return int + (float?'.'+float:'')
  },

  /**
   * 解析日期字符串
   * @param {string} 待解析的字符串 例: 2018-01-01 00:00:00
   * @return {array} 分离出的单个new Date()使用的数字 例: [2018,1,1,0,0,0]
   */
  getParsedDate(date){
    date = String(date).split(' ');
    var days = String(date[0]).split('-');
    var hours = String(date[1]).split(':');
    return [parseInt(days[0]), parseInt(days[1])-1, parseInt(days[2]), parseInt(hours[0]), parseInt(hours[1]), parseInt(hours[2])];
  },

  /**
   * 格式化时间戳
   * @param {string} timestamp 时间戳
   * @return {string} 格式化后的字符串 yyyy-MM-DD hh:mm:ss
   */
  timestampToTime(timestamp) {
    let date = new Date(timestamp) //时间戳为10位需*1000，时间戳为13位的话不需乘1000
    let mendZero = (value)=>{
      return parseInt(value) < 10 ?  `0${value}` : value
    }
    return `${date.getFullYear()}-${mendZero(date.getMonth()+1)}-${mendZero(date.getDate())} ${mendZero(date.getHours())}:${mendZero(date.getMinutes())}:${mendZero(date.getSeconds())}`
  },

  /**
   * 格式化商品价格
   * @param {number} price
   * @return {string} 格式化后的结果
   */
  formatPrice(price){
    let priceStr = String(price/10000);
    return (priceStr.indexOf(".")===-1)||(priceStr.length - priceStr.indexOf(".")===2)?(price/10000).toFixed(2):(price/10000);
  },

  addPreZero(number, bit = 1){
    let max = 10*bit,
        num = Number(number)
    let pre = ''
    for(let i=0; i<bit; i++){
      pre += '0'
    }
    return num < max ? `${pre}${num}` : num
  }
}


// WEBPACK FOOTER //
// ./src/utils/index.js